module.exports = __webpack_public_path__ + "static/media/safari-logo.0e029c10.svg";